module.exports = __webpack_public_path__ + "img/circle-arrow.7268d421.svg";